var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEscrituraYCorrecion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39024 25L28.5366 1L30 2.5L5.85366 26.5L2.92683 28L4.39024 25Z",
    fill: "#359C4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39024 25L28.5366 1L30 2.5L5.85366 26.5M4.39024 25L5.85366 26.5M4.39024 25L2.92683 28L5.85366 26.5M0 31H30",
    stroke: "#359C4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscrituraYCorrecion);
export default __webpack_public_path__ + "static/media/Escritura-y-correcion.5d29ee5dc17f3cf515ac1394bf62376f.svg";
export { ForwardRef as ReactComponent };